<template>
  <div>
    <quill-editor
      ref="myQuillEditor"
      v-model="content"
      :class="[
        `text-editor`,
        error && `text-editor--error`]"
      :options="editorOption"
      @change="onEditorChange($event)"
    />
    <span v-if="maxLength" class="text-editor__length">{{ length }} / {{ maxLength }}</span>
    <span v-if="error" class="form-label form-label--error form-label--error--active">{{ errorMsg }}</span>
  </div>
</template>

<script>
import { toolbarTextEditorValues } from "./constant.js";

export default {
  props: {
    defaultComments: { type: String, default: "" },
    errorMsg: { type: String, default: "" },
    error: { type: Boolean, default: false },
    maxLength: {type: Number}
  },
  data() {
    return {
      content:
        this.defaultComments ||
        `<p class="question"><b></b></p>`,
      editorOption: {
        modules: {
          toolbar: toolbarTextEditorValues
        },
        placeholder: "Enter Comments...",
      },
      length: 0
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  methods: {
    onEditorChange({ html, text }) {
      const data = {
          html,
          plainText: text,
        };
        this.length = text.length - 1
        this.$emit("commentsChange", data);
        this.content = html;
    },
  },
};
</script>

<style lang="scss">
@import "../../styles/imports";

.quill-editor {
  width: 100%;
  @include media("<=992px") {
    width: 100%;
  }
  .ql-toolbar {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .ql-container {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .ql-editor {
    height: 120px;
    color: var(--primary-text);
  }
  .ql-toolbar .ql-snow {
    svg {
      path {
        fill: white;
      }
    }
  }
}
.text-editor {
  &--error{
    .ql-toolbar.ql-snow {
      border: 1px solid var(--Danger);
    }
    .ql-container.ql-snow {
      border: 1px solid var(--Danger);
    }
  }
  &__length {
    display: flex;
    justify-content: flex-end;
    font-size: 14px;
    color: #727272;
  }
}
</style>